import {LogicalWidgetEventStruct} from '../logical-widget-event.struct';
import {DeviceWidgetEnum, FirmwareLogicalWidgetEnum} from '../../../../enums';

export class FirmwareLogicalWidgetEventStruct extends LogicalWidgetEventStruct {
  public event_firmware_logical_widget_type: FirmwareLogicalWidgetEnum;
} // end Package
